export default {"src":"/_next/static/media/arrow-right.83a5bb65.svg","height":22,"width":14,"blurWidth":0,"blurHeight":0};